import { IReminder, Therapy } from '@alberta/konexi-shared';
import { removeTime } from 'src/app/common/tracking/tracker';
import { BaseViewModel } from 'src/app/common/viewmodel/base-view-model';

export class ReminderViewModel extends BaseViewModel implements IReminder {
  hasBeenSeen: boolean;
  entityType: 'singleOrder' | 'integratedCare';
  entityId: string;
  parentId: string;
  therapy: Therapy;
  patientId: string;
  regionId: string;
  @removeTime()
  date: Date;
  annotation: string;
  userId: string;
}
